export const mappingPhoto = (object) => {
  return object
}
